import AttachmentsList from '@app/components/AttachmentsList'
import PhotoStrip from '@app/components/PhotoStrip'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { PropertyPageProps } from './PropertyPage'

export default class PropertyFiles extends React.PureComponent<
  PropertyPageProps
> {
  public render() {
    return (
      <DocumentTitle title={`${this.props.property.name} :: Files`}>
        <div className='mb-3'>
          <h5 className='section-title'>Photos</h5>
          <div className='mx-3'>
            <PhotoStrip
              photos={this.props.property.photos}
              propertyId={this.props.property.id}
            />
          </div>
          <h5 className='section-title'>Attachments</h5>
          <AttachmentsList
            attachments={this.props.property.attachments}
            className='mx-3'
            propertyId={this.props.property.id}
            onChange={this.props.setAttachments}
          />
        </div>
      </DocumentTitle>
    )
  }
}
